<template>
  <article class="content-container node-page">
    <template v-if="hasContent">
      <h2 class="article-title" :class="{'show-title': showTitle,'hide-title': !showTitle}">{{title}}</h2>
      <template v-if="content.hasImage">
        <figure class="main-image">
          <vue-picture :imgset="content.image" :sizes="fullSizes" :className="content.image.attributes.className"></vue-picture>
        </figure>
      </template>
      <div class="body" v-html="content.body"></div>
    </template>
  </article>
</template>

<script>
import _ from 'lodash'
import scrollTo from 'vue-scrollto'
import VuePicture from './VuePicture.vue'
import ImageManager from './ImageManager.vue'

export default {
  name: 'node',
  directives: {
    scrollTo
  },
  mixins: [ImageManager],
  data: function () {
    return {
      title: 'About',
      hasContent: false,
      content: {},
      fullSizes: {},
      updating: false,
      showTitle: true,
      loader: null
    }
  },
  beforeRouteEnter: function (to,from,next) { 
    next(function(vm) {
      if (typeof vm.updateContent == 'function') {
        vm.updateContent(true)
      }
    })
  },
  created: function () {
    this.$parent.$on('node-update', this.updateContent)
  },
  methods: {
    updateContent: function (init) {
      if (!init) {
        init = false
      }
      if (init !== true || this.$parent.infoLoaded) {
        this.updateNode()
      } else {
        var comp = this
        this.loader = setInterval(function () {
          if (comp.$parent.infoLoaded) {
            comp.updateNode()
          }
        }, 200)
      }
    },
  	updateNode: function() {

  		if (!this.updating) {
        if (this.$parent.hasContent) {
          this.updating = true
          this.title = this.$parent.title
          this.hasContent = this.$parent.hasContent
          this.content = this.$parent.content
          this.fullSizes = this.$parent.fullSizes
          if (this.loader) {
            clearInterval(this.loader)
          }
          this.showTitle = this.content.hasImage == false
          var comp = this
          if (this.content.hasImage) {
            this.filterImgSizes(this.content.image.sizes)
          }
          setTimeout(function () {
            comp.updating = false
            comp.$parent.removeContainerClass('loading')
          }, 50)
        }
  		}
  	}
  },
  components: {
    VuePicture
  }
}
</script>




// WEBPACK FOOTER //
// Node.vue?6eb7ea42